import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import ServiceDetails from './components/ServiceDetails';
import Stats from './components/Stats';
import WhyUs from './components/WhyUs';
import Clients from './components/Clients';
import Testimonials from './components/Testimonials';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import ThankYou from './components/ThankYou';
import { Toaster } from './components/ui/toaster';

function LandingPage() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Services />
        <ServiceDetails />
        <Stats />
        <WhyUs />
        <Clients />
        <Testimonials />
        <Gallery />
        <Contact />
      </main>
      <Footer />
      {/* Spacer so mobile sticky call/whatsapp bar doesn't cover content */}
      <div className="h-14 md:hidden" />
      <FloatingButtons />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/thanks" element={<ThankYou />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
